<template>
    <div class="services-container">
        <div class="left-menu">
            <div class="menu-title">客户服务</div>
            <div class="menu-box" v-for="(item,index) in list" :key="index">
                <div :class="['menu-item',{active:curr_index == index}]" @click="onParentClick(item,index)">
                    <Icon :type="item.show_child ? 'md-remove' :'md-add'" class="item-icon" />
                    <div class="item-text">{{ item.title }}</div>
                </div>
                <div class="child-menu-item" v-if="item.show_child && item.children && item.children.length>0">
                    <div :class="['child-item',{active:curr_child == ci}]" v-for="(child,ci) in item.children" :key="ci" @click="onChildClick(child,index,ci)">{{child.title}}</div>
                </div>
            </div>
        </div>
        <div class="right-content">
            <div class="rule-title">{{curr_content.title}}</div>
            <div class="rule-content" v-html="curr_content.content"></div>
        </div>
    </div>
</template>
<script>
import { GetCustomerServiceList } from '@/api/index';
export default{
    data(){
        return{
            list:[],
            curr_index:'',
            curr_child:'',
            curr_content:{}
        }
    },
    async mounted(){
        await this.getCustomerServiceList();
        const {id} = this.$route.query;
        if(id){
           this.onInitData(id);
        }
    },
    beforeRouteUpdate(to,from,next){
        // console.log('toooo',to);
        const {id} = to.query;
        // console.log('id',id);
        if(id){
           this.onInitData(id);
        }
        next();
    },
    beforeRouteEnter(to,from,next){
        next((vm)=>{
            vm.$emit('changeFooter','mall');
        })
    },
    methods:{
        onInitData(id){
            if(!id) return;
            const curr_item = this.list.find((item)=>item.id == id);
            // console.log('curr_item',curr_item);
            if(curr_item){
                this.curr_index = this.list.indexOf(curr_item);
                this.list = this.list.map((item)=>{
                    item.show_child = false;
                    return item;
                });
                this.list[this.curr_index].show_child = true;
                if(curr_item.type == 2){
                    this.curr_content = curr_item;
                }
                if(curr_item.type == 1 && curr_item.children && curr_item.children.length>0){
                    this.curr_content = curr_item.children[0];
                    console.log(this.curr_content);
                }
            }
        },
        onChildClick(data,p_index,c_index){
            this.curr_index = p_index;
            this.curr_child = c_index;
            this.curr_content = data;
        },
        onParentClick(data,index){
            this.curr_index = index;
            this.curr_child = '';
            this.list = this.list.map((item)=>{
                item.show_child = false;
                return item;
            });
            this.list[index].show_child = true;
            if(data.type == 2){
                this.curr_content = data;
            }
            if(data.type == 1 && data.children && data.children.length>0){
                this.curr_content = data.children[0];
            }
        },
        async getCustomerServiceList(){
            const {code,msg,data} = await GetCustomerServiceList();
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            console.log('data',data);
            this.list = data.map((item)=>{
                return {
                    ...item,
                    show_child:false
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.services-container{
    width:100%;
    height:calc(100vh - 80px);
    background:#f8f9fb;
    display:flex;
    justify-content:center;
    column-gap:20px;
    padding-top:25px;
    padding-bottom:50px;
    .left-menu{
        width:220px;
        height:100%;
        background:#fff;
        padding:0 10px;
        display:flex;
        flex-direction:column;
        overflow-x:hidden;
        .menu-title{
            width:100%;
            border-bottom:1px solid #e3e3e3;
            padding:24px 10px 16px 10px;
            font-size:20px;
            font-weight:bold;
            color:#333;
            margin-bottom:20px;
        }
        .menu-box{
            display:flex;
            flex-direction:column;
            width:100%;
            .menu-item{
                width:100%;
                height:38px;
                display:flex;
                align-items:center;
                cursor:pointer;
                padding-left:10px;
                &.active, &:hover{
                    background:#f5f5f5;
                }
                .item-icon{
                    width:16px;
                    height:16px;
                    color:#999;
                    border:1px solid #999;
                }
                .item-text{
                    font-size:16px;
                    color:#333;
                    padding-left:10px;
                }
                
            }
            .child-menu-item{
                margin-left:24px;
                margin-top:6px;
                display:flex;
                flex-direction:column;
                row-gap:10px;
                .child-item{
                    color:#666;
                    font-size:14px;
                    cursor:pointer;
                    display:flex;
                    align-items:center;
                    &.active,&:hover{
                        color:#ff5967;
                    }
                    &::before{
                        content:"●";
                        font-size:14px;
                        color:#666;
                        padding-right:10px;
                    }
                }
            }
        }
        
    }
    .right-content{
        flex:0 0 1100px;
        height:100%;
        background:#fff;
        padding:0 30px;
        display:flex;
        flex-direction:column;
        .rule-title{
            width:100%;
            text-align:center;
            border-bottom:1px solid #e3e3e3;
            padding-bottom:16px;
            padding-top:24px;
            color:#333;
            font-size:20px;
            font-weight:bold;
        }
        .rule-content{
            margin-top:24px;
            width:100%;
            flex:1;
            overflow-y:auto;
            padding-bottom:30px;
        }
    }
}
</style>